<template>
  <transition name="fade">
    <div class="wbs-loading" v-if="loading">
      <div class="wbs-loading__indicator">
        <i class="mdi mdi-spin mdi-loading"></i> Carregando...
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "appLoading",
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.wbs-loading {
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(225, 225, 225, 0.9);
  z-index: 100;
  align-items: center;

  @include element("indicator") {
    font-weight: 600;
    font-size: 1.4em;
    margin: 0 auto;
  }
}
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-leave-to {
  opacity: 0;
}
</style>
